import * as React from "react";
const BellIcon = ({
  size = 16,
  title = "BellIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.153 14.302a1.369 1.369 0 0 1-.488.511 1.284 1.284 0 0 1-1.33 0 1.369 1.369 0 0 1-.488-.51M12 5.2a4.31 4.31 0 0 0-1.172-2.97A3.905 3.905 0 0 0 8 1c-1.06 0-2.078.443-2.828 1.23A4.31 4.31 0 0 0 4 5.2c0 4.902-2 6.302-2 6.302h12s-2-1.4-2-6.301Z", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
export default BellIcon;
